import { AuthProvider } from './../auth/auth';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { Observable } from 'rxjs';
import { ENV } from '../../environments/environment';

export interface MaintenanceStatus {
  'message'?:  string;
  'enabled'?:  boolean;
}

@Injectable()
export class UtilsProvider {
  constructor(
    public http: HttpClient,
    public alertCtrl: AlertController,
    private authProvider: AuthProvider
  ) { }

  handleGraphError(error, display = false) {
    const message =
      error.networkError &&
        error.networkError.error &&
        error.networkError.error.errors
        ? error.networkError.error.errors.map(err => err.message).join('. ')
        : 'An unknown error occurred';
    if (display) {
      let alert = this.alertCtrl.create({
        title: 'Error',
        message: message,
        buttons: ['OK']
      });
      alert.present();
      // this.displayError(msg);
    }
  }

  handleAPIError(error, display = false) {
    console.log('ERROR::: ', error);
    const message =
      error && error.error && error.error.message
        ? error && error.error && error.error.message
        : 'An unknown error occurred';
    if (display) {
      let alert = this.alertCtrl.create({
        title: 'Error',
        message: message,
        buttons: ['OK']
      });
      alert.present();
      // this.displayError(msg);
    }
  }

  uploadImages(images, id = 0, obs = null, taskid) {
    let observer;
    setTimeout(() => {
      let blob = this.b64toBlob(images[id].data, 'image/jpeg');
      let formData: FormData = new FormData();
      let fileName = 'image' + id + '.jpg';
      formData.append('imageFile', blob, fileName);
      this.authProvider.getOptions().subscribe(options => {
        let api = ENV.api + '/api/images';
        this.http.post(api, formData, options).subscribe(
          uploadResult => {
            observer.next({
              data: {
                src: (uploadResult as any).url,
                label: images[id].label ? images[id].label : '',
                tag: images[id].tag ? images[id].tag : '',
                comment: images[id].comment ? images[id].comment : ''
              },
              id: id
            });
            if (id < images.length - 1) {
              this.uploadImages(images, id + 1, observer, taskid);
            } else {
              observer.complete();
            }
          },
          e => {
            observer.complete();
          }
        );
      });
    }, 100);

    let obsobj;
    if (obs) {
      observer = obs;
    } else {
      obsobj = Observable.create(obs => {
        observer = obs;
      });
    }
    return obsobj;
  }

  b64toBlob(b64Data, contentType = '', sliceSize: number = 512) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  toHTMLlinks(arr: Array<any>) {
    console.log(arr);
    let links = '';
    for (let i = 0; i < arr.length; i++) {
      links += '<a href="' + arr[i] + '">Image ' + (i + 1) + '</a><br>';
    }
    return links;
  }

  toDataURL = url =>
    fetch(url)
      .then(response => response.blob())
      .then(
        blob =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  getMetadata() {
    return Observable.create(observer => {
      let api = ENV.manifest
      const location = window.location.href + '';
      // Check where to get manifest
      if ((location.includes('dev') && !location.includes('https://sn')) || location.includes('prod.storage')) {
        api = ENV.manifest2;
      }
      if (!location.includes('localhost')) {
        this.http
          .get(api)
          .subscribe(response => {
            observer.next(response);
          }, e => {
            observer.next(e);
          })
      } else {
        observer.next({});
      }
    });
  }
  checkVersion() {

    try {
      this.getMetadata().subscribe(ret => {
        if (!ret || (ret && !ret.version)) {
          console.log('No Manifest App version: ', (ret));
        }
        const appversionStr = ret && ret.version ? ret.version : "0.0.0"
        const localVersion: string = localStorage.getItem('app-version');

        if (localVersion) {
          if (localVersion !== appversionStr) {
            if (ret && ret.version) {
              this.clearCache();
            } else {
              console.log('Not Clearing', appversionStr, localVersion)
            }
          }
        } else {
          console.log("Setting App version", appversionStr)
          localStorage.setItem('app-version', appversionStr + "")
        }
      });
    } catch (e) {
      console.log('Version check fail!')
    }

  }

  clearCache() {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (let registration of registrations) {
        registration.unregister();
      }
    }).then(() => {
      console.log('Reloading Now')
      localStorage.removeItem('app-version')
      window.location.reload();

    }).catch((err) => {
      console.log("Task Service Worker Error: ", err)
    });
  }

  checkMaintenanceMode() {
    return Observable.create(observer => {
      const api = ENV.base + `/sensor-desk/maintenance`;
      this.authProvider.getOptions().subscribe(options => {
        this.http.get(api, options).subscribe(
          result => {
            const maintenanceActive = (result as MaintenanceStatus);
            observer.next(maintenanceActive);
          },
          error => {
            console.log('error', error);
          }
        );
      });
    });
  }

  groupSnnToName(item: string): string {
    if (item && item.includes("snn:group:company:")) {
      const name = item.replace("snn:group:company:", "");
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
    return item;
  }
}



// WEBPACK FOOTER //
// ./src/providers/utils/utils.ts